'use client'

import { faChevronLeft, faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ReactNode, useRef } from 'react';

const HorizontalScroll = ({ children, className = '', buttonClasses, offset }: { children: ReactNode, className?: string, buttonClasses?: string, offset?: string }) => {
    const scrollContainerRef = useRef<any>(null);

    const scrollLeft = () => {
        scrollContainerRef.current.scrollBy({ left: -340, behavior: 'smooth' });
    };

    const scrollRight = () => {
        scrollContainerRef.current.scrollBy({ left: 340, behavior: 'smooth' });
    };
    return (
        <div className={`${className} relative w-full overflow-y-visible`}>
            <button
                onClick={scrollLeft}
                className={`${buttonClasses}  hidden absolute left-2 w-6 h-6 hover:scale-105 transition-transform duration-300 md:flex items-center justify-center top-1/2 transform -translate-y-1/2 bg-white aspect-square px-1 rounded-full shadow-md z-30`}
            >
                <FontAwesomeIcon icon={faChevronLeft} className='text-gray-600 w-4' />
            </button>
            <div
                ref={scrollContainerRef}
                className="flex overflow-x-auto overflow-visible gap-2 no-scroller scrollbar-hide scroll-smooth relative z-0"
            >
                {children}
            </div>
            <button
                onClick={scrollRight}
                className={`${buttonClasses}   hidden absolute right-2 w-6 h-6 hover:scale-105 transition-transform duration-300 md:flex items-center justify-center top-1/2 transform -translate-y-1/2 bg-white aspect-square px-1 rounded-full shadow-md z-30`}
            >
                <FontAwesomeIcon icon={faChevronRight} className='text-gray-600 w-4' />
            </button>
        </div>
    );
};

export default HorizontalScroll;
